import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#333333",
		d: "M6.818 11.62L3.955 8.798 3 9.739 6.818 13.5 15 5.44l-.954-.94-7.228 7.12z"
	})
});
export default SvgIconCheck;
